<template>
  <el-row :gutter="24" type="flex" align="middle" class="cc-item ta-c">
    <el-col :span="2">
      <el-checkbox :label="item.id" />
    </el-col>
    <el-col :span="3" class="date">
      {{ dateToFormat(item.created_at, 'respStatusDate') }}
    </el-col>
    <type-and-fio :id="item.user_id" :type="item.type" />
    <el-col :span="6" class="ta-l">
      {{ item.description }}
    </el-col>
    <task-stats :stats="item.stats" />
    <el-col :span="2" class="status">
      <img
        v-if="+item.status === 1"
        src="@/assets/img/call-center-status-half.png"
      />
      <img
        v-if="+item.status === 2"
        src="@/assets/img/call-center-status.png"
      />
    </el-col>
    <action-buttons @call="onCall" @del="onDel" />
  </el-row>
</template>

<script>
import { mapActions } from 'vuex'
import ActionButtons from './ActionButtons'
import TaskStats from './TaskStats'
import TypeAndFio from './TypeAndFio'

export default {
  name: 'CCItem',
  components: { ActionButtons, TypeAndFio, TaskStats },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    ...mapActions({ deleteTask: 'callCenter/deleteTask' }),
    onCall() {
      this.$emit('set', 'callModal', this.item.id)
    },
    onDel() {
      this.$confirm('Вы уверены что хотите удалить задание?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
      })
        .then(() => this.deleteTask(this.item.id))
        .catch(() => {})
    },
  },
}
</script>

<style lang="sass">
.cc-item
  min-height: 80px
  background: #fff
  margin-top: 20px
  font-size: 14px
  padding: 15px 0
  .el-checkbox__label
    display: none
  .date
    font-size: 16px
    color: #8694A4
  .info
    p
      font-weight: bold
      margin: 0
      line-height: 24px
      &.red
        color: #ff0000
      &.green
        color: #2ecc71
    .ml-10
      padding-left: 10px
  .status
    height: 46px
    img
      width: 46px
  .btn-block
    display: flex
    align-items: center
    justify-content: center
    .call
      height: 40px
      padding: 0
      border: 0
      &:hover
        opacity: 0.7
      img
        width: 40px
  .cc-adm-item .el-loading-spinner
    margin-top: -8px
</style>
